import imageCompression from "browser-image-compression";
import store from "~/src/store";

export default async (imageFile) => {
  if (imageFile instanceof Blob) {
    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      return await imageCompression(imageFile, options);
    } catch (error) {
      store.dispatch("SET_SNACKBAR", {
        text: "File compression error",
        color: "error",
      });
      console.log(error);
      return null;
    }
  } else {
    return null;
  }
};
